import {Nullable} from "primereact/ts-helpers";

export class Booking {
    id!: string;
    name!: string;
    amount!: number;
    slotId!: string;
    phone: Nullable<string>;
    email: Nullable<string>;
    comment: Nullable<string>;
}

export class NewBooking {
    name: string;
    amount: number;
    slotId: string;
    phone: Nullable<string>;
    email: Nullable<string>;
    comment: Nullable<string>;

    constructor(
        name: string,
        amount: number,
        slotId: string,
        phone: Nullable<string> = null,
        mail: Nullable<string> = null,
        comment: Nullable<string> = null,
    ) {
        this.name = name;
        this.amount = amount;
        this.slotId = slotId;
        this.phone = phone;
        this.email = mail;
        this.comment = comment;
    }
}
